var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUploadIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 31,
    height: 32,
    viewBox: "0 0 31 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_91",
    "data-name": "Rectangle 91",
    width: 28,
    height: 28,
    rx: 10,
    transform: "translate(-0.444 -0.444)",
    fill: "#fff",
    stroke: "#24539b",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_37",
    "data-name": "Group 37",
    transform: "translate(-623 -481)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_36",
    "data-name": "Group 36"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_34",
    "data-name": "Group 34",
    transform: "translate(9.444 4.444)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_90",
    "data-name": "Rectangle 90",
    transform: "translate(613.556 480.556)",
    fill: "#fff",
    stroke: "#24539b",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 10,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 27,
    height: 27,
    rx: 9.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_7",
    "data-name": "Mask Group 7",
    transform: "translate(614 481)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_33",
    "data-name": "Group 33",
    transform: "translate(-3.991 13.929)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_48",
    "data-name": "Path 48",
    d: "M14477.931,511.663c.776-.776,13.54-13.627,13.54-13.627l11.385,13.627Z",
    transform: "translate(-14477.931 -498.037)",
    fill: "#21bcd8",
    stroke: "#24539b",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49",
    "data-name": "Path 49",
    d: "M14477.932,508.652c.6-.6,10.547-10.615,10.547-10.615l8.869,10.615Z",
    transform: "translate(-14464.547 -495.025)",
    fill: "#21bcd8",
    stroke: "#24539b",
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_92",
    "data-name": "Rectangle 92",
    transform: "translate(613.556 480.556)",
    fill: "none",
    stroke: "#24539b",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 10,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 27,
    height: 27,
    rx: 9.5,
    fill: "none"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_35",
    "data-name": "Group 35",
    transform: "translate(-3)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_25",
    "data-name": "Ellipse 25",
    cx: 9,
    cy: 9,
    r: 9,
    transform: "translate(639 481)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "arrow-small-up",
    d: "M14.009,8.341,11.068,5.406a1.368,1.368,0,0,0-1.929,0L6.2,8.341a.684.684,0,1,0,.971.964l2.25-2.25v7.524a.684.684,0,1,0,1.368,0V7.055l2.25,2.25a.684.684,0,1,0,.971-.964Z",
    transform: "translate(637.896 479.865)",
    fill: "#24539b"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/uploadIcon.c20663933acd8901c6d318e3a4f3bf42.svg";
export { ForwardRef as ReactComponent };